
import { Vue, prop } from "vue-class-component";

class Props {
  goodsNames = prop<string>({
    required: true,
    default: "",
    type: String
  });
}

export default class GoodsNames extends Vue.with(Props) {}
